import axios from 'axios';
import environnement from '../environnement';

const instanceOfAxios = axios.create({ baseURL: environnement.axios, withCredentials: true })

export default instanceOfAxios;